{
	"placeholder": "Seleccionar período",
	"filterBy": "Filtrar por:",
	"applyPeriod": "Definir período",
	"ariaLabels": {
		"selectDateRange": "Seleccionar rango de fechas",
		"dateRangeDialog": "Selección de rango de fechas",
		"dateRangeSelection": "Calendario de selección de rango de fechas",
		"clearSelection": "Limpiar selección de fechas"
	}
}
